import type { I_RadiusLocation } from "../../shared/types.ts";

interface I_ResultTable {
    locations: I_RadiusLocation[]
    loading: boolean
}

// Rendering every row of a wide radius would stall the page, the export always holds the full set
const VISIBLE_ROWS = 500;

const ResultTable = ({ locations, loading }: I_ResultTable) => {
    if (loading) return <p className="hint">Wird gesucht …</p>;
    if (locations.length === 0) return <p className="hint">Startort und Umkreis wählen, um Orte zu finden.</p>;

    const shown = locations.slice(0, VISIBLE_ROWS);

    return (
        <div className="table-wrap">
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Name 2</th>
                        <th>PLZ</th>
                        <th>Land</th>
                        <th>Region</th>
                        <th className="right">Entfernung</th>
                    </tr>
                </thead>
                <tbody>
                    {shown.map((location) => (
                        <tr key={location.id} className={location.isOrg ? "is-org" : ""}>
                            <td>{location.name}</td>
                            <td>{location.name2}</td>
                            <td>{location.zipcode}</td>
                            <td>{location.countryCode}</td>
                            <td>{location.admin1}</td>
                            <td className="right">{location.distanceKm.toLocaleString("de-DE", { minimumFractionDigits: 1 })} km</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {locations.length > shown.length && (
                <p className="hint">
                    Es werden {shown.length.toLocaleString("de-DE")} von {locations.length.toLocaleString("de-DE")} Zeilen angezeigt, der Export enthält alle.
                </p>
            )}
        </div>
    )
}
export default ResultTable;